
(function(){
  var nav=document.getElementById('nav'),t=document.getElementById('navToggle');
  if(nav&&t){
    t.addEventListener('click',function(){
      var open=nav.classList.toggle('open');
      t.setAttribute('aria-expanded',open?'true':'false');
    });
    document.querySelectorAll('#navLinks a').forEach(function(a){
      a.addEventListener('click',function(){nav.classList.remove('open');t.setAttribute('aria-expanded','false');});
    });
  }
})();
(function(){
  var t=document.getElementById('railTrack');
  if(t){
    t.innerHTML+=t.innerHTML;
    var rail=t.parentElement, freed=false, half=0;

    // hand the rail over from the CSS marquee to the user, keeping its exact position
    function free(){
      if(freed) return; freed=true;
      var tx=0;
      try{
        var m=new DOMMatrixReadOnly(getComputedStyle(t).transform);
        tx=m.m41||0;
      }catch(e){}
      t.style.animation='none';
      t.style.transform='none';
      half=t.scrollWidth/2;
      rail.scrollLeft=-tx;
      rail.classList.add('is-free');
      try{clearInterval(marquee);}catch(e){}
    }

    ['pointerdown','touchstart','wheel','keydown'].forEach(function(ev){
      rail.addEventListener(ev,free,{passive:true,once:false});
    });

    // wrap only once the swipe has settled, so momentum is never cut short
    var wrapping=false, settle=0;
    rail.addEventListener('scroll',function(){
      if(!freed||wrapping||!half) return;
      clearTimeout(settle);
      settle=setTimeout(function(){
        if(rail.scrollLeft>=half||rail.scrollLeft<=0){
          wrapping=true;
          var snap=rail.style.scrollSnapType; rail.style.scrollSnapType='none';
          rail.scrollLeft += (rail.scrollLeft>=half ? -half : half);
          rail.style.scrollSnapType=snap;
          wrapping=false;
        }
      },140);
    },{passive:true});

    /* ---- centred card plays, everything else pauses ---- */
    var cards=[].slice.call(t.children), visible=true, tickQueued=false;

    function setActive(){
      tickQueued=false;
      var rr=rail.getBoundingClientRect(), mid=rr.left+rr.width/2, best=null, bd=1e9;
      for(var i=0;i<cards.length;i++){
        var b=cards[i].getBoundingClientRect();
        if(b.right<rr.left-60||b.left>rr.right+60) continue;
        var d=Math.abs(b.left+b.width/2-mid);
        if(d<bd){bd=d;best=cards[i];}
      }
      for(var j=0;j<cards.length;j++){
        var c=cards[j], on=(c===best&&visible);
        if(c.classList.contains('is-active')===on) continue;
        c.classList.toggle('is-active',on);
        var v=c.querySelector('video');
        if(!v) continue;
        if(on){
          var pr=v.play();
          if(pr&&pr.then) pr.then(function(el){return function(){el.classList.add('is-playing');};}(c)).catch(function(){});
          else c.classList.add('is-playing');
        }else{
          v.pause(); try{v.currentTime=0;}catch(e){}
          v.muted=true; c.classList.remove('is-playing');
          var ic=c.querySelector('.pcard-sound use');
          if(ic) ic.setAttribute('href','#snd-off');
        }
      }
    }
    function tick(){ if(tickQueued) return; tickQueued=true; requestAnimationFrame(setActive); }
    rail.addEventListener('scroll',tick,{passive:true});

    // while the marquee is still running there are no scroll events to listen to
    var marquee=setInterval(tick,180);

    // never play audio or video for a rail nobody is looking at
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(e){
        visible=e[0].isIntersecting;
        if(!visible){
          cards.forEach(function(c){
            var v=c.querySelector('video');
            if(v){v.pause();v.muted=true;}
            c.classList.remove('is-playing','is-active');
          });
        }
        tick();
      },{threshold:.25}).observe(rail);
    }

    // tap the playing card to turn its sound on
    rail.addEventListener('click',function(e){
      var c=e.target.closest?e.target.closest('.pcard'):null;
      if(!c) return;
      var v=c.querySelector('video'); if(!v) return;
      cards.forEach(function(o){
        if(o===c) return;
        var ov=o.querySelector('video');
        if(ov&&!ov.muted){ ov.muted=true; var oi=o.querySelector('.pcard-sound use'); if(oi) oi.setAttribute('href','#snd-off'); }
      });
      v.muted=!v.muted;
      var ic=c.querySelector('.pcard-sound use');
      if(ic) ic.setAttribute('href', v.muted?'#snd-off':'#snd-on');
      if(!v.muted) v.play().catch(function(){});
    });
    tick();

    // click-and-drag for mouse (touch already scrolls natively)
    var down=false,x0=0,s0=0,moved=0,swallowClick=false;
    rail.addEventListener('pointerdown',function(e){
      if(e.pointerType==='touch') return;
      down=true;moved=0;x0=e.clientX;s0=rail.scrollLeft;
      rail.setPointerCapture(e.pointerId);
      rail.classList.add('is-drag');
    });
    rail.addEventListener('pointermove',function(e){
      if(!down) return;
      var d=e.clientX-x0; moved=Math.abs(d);
      rail.scrollLeft=s0-d;
      e.preventDefault();
    });
    ['pointerup','pointercancel','pointerleave'].forEach(function(ev){
      rail.addEventListener(ev,function(e){
        if(!down) return; down=false;
        swallowClick=(moved>6); moved=0;
        rail.classList.remove('is-drag');
        try{rail.releasePointerCapture(e.pointerId);}catch(err){}
      });
    });
    // a drag must never register as a tap — but only the drag that just ended
    rail.addEventListener('click',function(e){
      if(swallowClick){swallowClick=false;e.preventDefault();e.stopPropagation();}
    },true);
  }
  var s=document.getElementById('sticky'),h=document.querySelector('.hero');
  if(s&&h&&'IntersectionObserver' in window){
    new IntersectionObserver(function(e){s.classList.toggle('on',!e[0].isIntersecting);},{threshold:0})
      .observe(h);
  }
})();
